var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_171_3827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3748 0.492188H25.5065C24.2964 0.492188 23.2075 0.947695 22.3574 1.80958L11.4272 12.8959C10.6833 13.6502 10.2902 14.7297 10.2902 16.0177V61.0702C10.2902 63.5084 12.0393 65.4922 14.1894 65.4922H50.8976C53.0477 65.4922 54.7969 63.5084 54.7969 61.0702V4.91422C54.7969 2.47596 52.8131 0.492188 50.3748 0.492188ZM52.7656 61.0702C52.7656 62.3661 51.9102 63.4609 50.8976 63.4609H14.1894C13.1768 63.4609 12.3214 62.3661 12.3214 61.0702V16.0177C12.3214 15.2641 12.5071 14.6937 12.8735 14.3221L23.8041 3.23577C24.2767 2.75652 24.8337 2.52356 25.5066 2.52356H50.375C51.6933 2.52356 52.7658 3.59606 52.7658 4.91435V61.0702H52.7656ZM46.194 18.4418H18.893C18.3321 18.4418 17.8774 18.8966 17.8774 19.4575V58.1543C17.8774 58.7152 18.3321 59.1699 18.893 59.1699H46.1942C46.755 59.1699 47.2098 58.7152 47.2098 58.1543V19.4575C47.2097 18.8966 46.7549 18.4418 46.194 18.4418ZM45.1784 30.5416L45.1385 30.5185L41.5265 36.7746L38.0507 30.7545V20.473H45.1785V30.5416H45.1784ZM45.1784 34.5117V43.1002L42.6991 38.8059L45.1784 34.5117ZM29.0677 47.6009H36.0195V57.1387H29.0677V47.6009ZM36.4487 45.5697H28.6384L24.7331 38.8059L28.6384 32.0421H36.4487L40.3539 38.8059L36.4487 45.5697ZM36.0195 30.0108H29.0677V20.4731H36.0195V30.0108ZM27.0364 20.4731V30.7544L23.5604 36.7748L19.9485 30.5186L19.9086 30.5417V20.4731H27.0364ZM22.3878 38.8059L19.9086 43.0999V34.5118L22.3878 38.8059ZM19.9086 47.0701L19.9485 47.0933L23.5604 40.8371L27.0364 46.8575V57.1387H19.9085L19.9086 47.0701ZM38.0507 57.1387V46.8571L41.5265 40.8371L45.1385 47.0933L45.1784 47.0701V57.1387H38.0507Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_171_3827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimCardIcon);
export default __webpack_public_path__ + "static/media/sim-card-icon.3cea794df9dabbbd784b734970944e52.svg";
export { ForwardRef as ReactComponent };